import Vue from 'vue';
import VueI18n from 'vue-i18n';
import messages from '@kirschbaum-development/laravel-translations-loader/php?parameters={$1}!@kirschbaum-development/laravel-translations-loader'; // eslint-disable-line

Vue.use(VueI18n);

export default new VueI18n({
    locale: window.Laravel.locale,
    messages,
});
